import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableStoreComponent } from './table-store.component';
import {CardModule} from '../../components/card/card.module';
import {RouterModule} from '@angular/router';
import {SmartTableModule} from '../../modules/smart-table/smart-table.module';
import {MomentPipeModule} from '../../pipes/moment-pipe/moment-pipe.module';
import {BadgeExistModule} from '../../components/badge-exist/badge-exist.module';
import {IconsModule} from '../../components/icons/icons.module';
import {ReducerPipeModule} from '../../pipes/reducer-pipe/reducer-pipe.module';
import {NgxPopperModule} from 'ngx-popper';
import {PaginationModule} from '../../components/pagination/pagination.module';
import {PreloaderModule} from '../../components/preloader/preloader.module';
import {EntityLinkModule} from "../../components/entity-link/entity-link.module";
import {ModalDeleteModule} from "../../components/modals/modal-delete/modal-delete.module";
import {PortalModule} from "@angular/cdk/portal";
import {BtnDeleteModule} from "../../components/btn-delete/btn-delete.module";
import {ReactiveFormsModule} from "@angular/forms";
import {FormGroupSimpleModule} from "../../modules/form-group-context/form-group-simple/form-group-simple.module";
import {FormGroupSelectModule} from "../../modules/form-group-context/form-group-select/form-group-select.module";



@NgModule({
  declarations: [
    TableStoreComponent
  ],
  exports: [
    TableStoreComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    RouterModule,
    SmartTableModule,
    MomentPipeModule,
    BadgeExistModule,
    IconsModule,
    ReducerPipeModule,
    NgxPopperModule,
    PaginationModule,
    PreloaderModule,
    EntityLinkModule,
    ModalDeleteModule,
    PortalModule,
    BtnDeleteModule,
    ReactiveFormsModule,
    FormGroupSimpleModule,
    FormGroupSelectModule
  ],
})
export class TableStoreModule { }
